import axios from "axios";
import Config from "../../../config";

const v2_actionSendGroupMessage = (chatId, payload) => axios({
    method: "post",
    url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/groups/${chatId}/messages`,
    data: { payload }
});

export default v2_actionSendGroupMessage;
